import { render } from "./CheckoutComponent.vue?vue&type=template&id=4f3cf565&scoped=true"
import script from "./CheckoutComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutComponent.vue?vue&type=script&lang=js"

import "./CheckoutComponent.vue?vue&type=style&index=0&id=4f3cf565&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3cf565"]])

export default __exports__